/* eslint-disable no-underscore-dangle */
/* eslint-disable no-return-await */
import React, { useEffect, useState, useRef } from 'react';
import { Form } from '@unform/web';

import { FaEye, FaCheck } from 'react-icons/fa';

import {
  Button,
  Card,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Table,
  CardHeader,
} from 'reactstrap';
import ScrollableFeed from 'react-scrollable-feed';
import Swal from 'sweetalert2';
import { Input } from '../../components/unform/index';
import { useAuth } from '../../contexts/auth';
// import Contador from './contador';

import { Translator } from '../../components/i18n';

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'ml-3 btn btn-success',
    cancelButton: 'btn btn-danger',
  },
  buttonsStyling: false,
});

function Usuario() {
  const obrigatorio = Translator({
    path: 'obrigatorio',
  });
  const operacaoNaorevertida = Translator({
    path: 'operacaoNaorevertida',
  });
  const temcertezaAceitarChamado = Translator({
    path: 'temcertezaAceitarChamado',
  });
  const temcertezaConcluirChamado = Translator({
    path: 'temcertezaConcluirChamado',
  });
  const sim = Translator({
    path: 'sim',
  });
  const nao = Translator({
    path: 'nao',
  });
  const { user, socket, msgTodos, msgMinhas } = useAuth();
  const formRef = useRef();

  const [activeTab, setActiveTab] = useState('1');
  const [modal, setModal] = useState(false);

  const [salaId, setSalaId] = useState(null);
  const [msgs, setMsgs] = useState([]);

  const toggleModal = () => setModal(!modal);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    if (salaId) {
      const msgsSala = msgMinhas?.filter((ms) => ms?._id === salaId)[0]
        ?.mensagens;

      setMsgs(msgsSala);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salaId, msgMinhas]);

  async function handleAcept(id) {
    swalWithBootstrapButtons
      .fire({
        title: temcertezaAceitarChamado,
        text: operacaoNaorevertida,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: sim,
        cancelButtonText: nao,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          socket.emit('accept', { sala: id });
        }
      });
  }

  async function handleSubmitMsg(data) {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f] && f !== 'complemento' && f !== 'cep') {
        errors[f] = obrigatorio;
      }
    });

    formRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      socket.emit('message', { text: data?.msg, sala: salaId });

      formRef.current.setFieldValue('msg', '');
    }
  }

  async function handleConcluido(id) {
    swalWithBootstrapButtons
      .fire({
        title: temcertezaConcluirChamado,
        text: operacaoNaorevertida,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: sim,
        cancelButtonText: nao,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          socket.emit('concluido', { sala: id });
        }
      });
  }

  return (
    <>
      <Row>
        <Col>
          <h4 className="mb-3">Chat</h4>
        </Col>
      </Row>
      <Card>
        <CardHeader>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === '1' ? 'active' : ''}
                onClick={() => {
                  toggle('1');
                }}
              >
                <Translator path="chat.emaberto" />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === '2' ? 'active' : ''}
                onClick={() => {
                  toggle('2');
                  // setMsgMinhasCounter(0);
                }}
              >
                <Translator path="chat.meuschamados" />
                {/* <Contador /> */}
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
        <CardBody>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Table responsive>
                <thead>
                  <tr>
                    <th>
                      <Translator path="chat.solicitante" />
                    </th>
                    <th>
                      <Translator path="chat.assunto" />
                    </th>
                    <th className="text-center">
                      <Translator path="chat.acao" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {msgTodos?.length ? (
                    msgTodos?.map((sala) => (
                      <tr key={sala?.id}>
                        <td>{sala?.mensagens[0]?.user?.name}</td>
                        <td>{sala?.mensagens[0]?.text}</td>
                        <td className="text-center">
                          <Button
                            onClick={() => handleAcept(sala?._id)}
                            className="btn btn-sm"
                          >
                            <Translator path="chat.aceitar" />
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>
                        <Translator path="excecoes.semregistros" />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </TabPane>
            <TabPane tabId="2">
              <Table responsive>
                <thead>
                  <tr>
                    <th className="w-50">
                      <Translator path="chat.solicitante" />
                    </th>
                    <th className="text-center">
                      <Translator path="chat.acao" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {msgMinhas?.length ? (
                    msgMinhas?.map((sala) => (
                      <tr key={sala?._id}>
                        <td>{sala?.mensagens[0]?.user?.name}</td>
                        <td className="text-center">
                          <Row>
                            <Col>
                              <Button
                                block
                                onClick={() => {
                                  setSalaId(sala?._id);
                                  toggleModal();
                                }}
                                className="btn"
                              >
                                <FaEye size={20} />{' '}
                                <Translator path="chat.btnver" />
                              </Button>
                            </Col>
                            <Col>
                              <Button
                                block
                                onClick={() => handleConcluido(sala?._id)}
                                color="warning"
                                className="btn"
                              >
                                <FaCheck size={20} />{' '}
                                <Translator path="chat.concluido" />
                              </Button>
                            </Col>
                          </Row>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>
                        <Translator path="excecoes.semregistros" />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>

      <Modal isOpen={modal} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>
          <Translator path="chat.mensagens" />
        </ModalHeader>
        <Form ref={formRef} onSubmit={(data) => handleSubmitMsg(data)}>
          <ModalBody>
            <ScrollableFeed className="chat">
              {msgs?.length ? (
                msgs?.map((msg) =>
                  msg?.user?._id === user?.id ? (
                    <Card className="chat-baloon-1" key={msg?._id}>
                      <Row className="text-end">
                        <Col>
                          <h6>{msg?.text}</h6>
                        </Col>
                        <Col lg={2}>
                          <h6>{msg?.user?.name}</h6>
                        </Col>
                        <Col lg={3}>
                          <h6>{new Date(msg?.createdAt).toLocaleString()}</h6>
                        </Col>
                      </Row>
                    </Card>
                  ) : (
                    <Card className="chat-baloon-2" key={msg?._id}>
                      <Row className="text-start">
                        <Col lg={3}>
                          <h6>{new Date(msg?.createdAt).toLocaleString()}</h6>
                        </Col>
                        <Col lg={2}>
                          <h6>{msg?.user?.name}</h6>
                        </Col>
                        <Col>
                          <h6>{msg?.text}</h6>
                        </Col>
                      </Row>
                    </Card>
                  )
                )
              ) : (
                <Row>
                  <Col>
                    <h4>
                      <Translator path="chat.semmensagens" />
                    </h4>
                  </Col>
                </Row>
              )}
            </ScrollableFeed>
            <hr />
            <Input
              name="msg"
              label={<Translator path="chat.mensagem" />}
              className="form-control"
              type="text"
            />
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="Push.btnenviar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}

export default Usuario;
